import { render } from "./ListInsurances.vue?vue&type=template&id=4e67236c&scoped=true&ts=true"
import script from "./ListInsurances.vue?vue&type=script&lang=ts"
export * from "./ListInsurances.vue?vue&type=script&lang=ts"

import "./ListInsurances.vue?vue&type=style&index=0&id=4e67236c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e67236c"]])

export default __exports__